"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Strings_1 = require("../../Utility/Strings");
class LocalStorageEngine {
    constructor(baseKey, options) {
        var _a;
        this.baseKey = baseKey;
        this.options = options;
        this.vBaseKey = '';
        this.vBaseKey = this.baseKey.concat(LocalStorageEngine.VERSION);
        /* istanbul ignore next */
        this.storage = (_a = this.options.storage) !== null && _a !== void 0 ? _a : window.localStorage;
    }
    getValue(key) {
        const stored = this.storage.getItem(this.getFormattedKey(key));
        if (stored === null || stored === undefined) {
            return undefined;
        }
        const record = JSON.parse(stored);
        if (record.expiresAt !== undefined && record.expiresAt < new Date().getTime()) {
            return undefined;
        }
        return record.value;
    }
    setValue(key, value) {
        let expiresAt;
        if (this.options.ttl !== undefined) {
            expiresAt = new Date().getTime() + this.options.ttl;
        }
        const record = { expiresAt, value };
        this.storage.setItem(this.getFormattedKey(key), JSON.stringify(record));
    }
    clear() {
        this.keys().forEach(key => this.remove(key));
    }
    keys() {
        const keys = [];
        for (let i = 0; i < this.storage.length; i++) {
            const keyName = this.storage.key(i);
            /* istanbul ignore next */
            if (keyName === null || keyName === void 0 ? void 0 : keyName.startsWith(this.vBaseKey)) {
                keys.push(Strings_1.default.removePrefix(keyName, this.vBaseKey));
            }
        }
        return keys;
    }
    remove(key) {
        this.storage.removeItem(this.getFormattedKey(key));
    }
    getFormattedKey(key) {
        return this.vBaseKey + key;
    }
}
LocalStorageEngine.VERSION = 'v1.0';
exports.default = LocalStorageEngine;
//# sourceMappingURL=LocalStorageEngine.js.map